// extracted by mini-css-extract-plugin
export default {"individual":"styles_individual__nulDU","description":"styles_description__DHbBC","button":"styles_button__HTPsw"};